// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = require('./_export');

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});



//////////////////
// WEBPACK FOOTER
// C:/Users/vijay/L180/prototypes/uni-uswebapp/~/babel-polyfill/~/core-js/modules/es7.math.isubh.js
// module id = 593
// module chunks = 29